import React from 'react';
import DoctorLayout from '../doctor/DoctorLayout';
import { HEAD_DOCTOR_PATHS } from '../doctor/doctorPaths';

export default function HeadDoctorLayout() {
  return <DoctorLayout portalPaths={HEAD_DOCTOR_PATHS} forceHeadDoctor />;
}

